var _path, _rect, _rect2, _path2, _rect3, _rect4, _path3, _rect5, _rect6, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMilestones = function SvgMilestones(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 824 56"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#E2FFEA",
    strokeDasharray: "8 8",
    strokeWidth: 4,
    d: "M26.5 27.5h770"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    x: 8,
    y: 8,
    fill: "#51C394",
    rx: 20
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    x: 4,
    y: 4,
    stroke: "#51C394",
    strokeOpacity: 0.5,
    strokeWidth: 8,
    rx: 24
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M23.81 24.568v-3.096l7.368-1.56V37H27.84V23.512z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    x: 392,
    y: 8,
    fill: "#51C394",
    rx: 20
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    x: 388,
    y: 4,
    stroke: "#51C394",
    strokeOpacity: 0.5,
    strokeWidth: 8,
    rx: 24
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m404.933 37 7.632-7.968q.648-.696 1.104-1.296t.696-1.2.24-1.248q0-.456-.168-.888a2.2 2.2 0 0 0-.504-.768 2.4 2.4 0 0 0-.816-.528 2.7 2.7 0 0 0-1.104-.216q-.888 0-1.536.432-.624.408-.984 1.176-.336.768-.336 1.776h-3.36q0-1.8.72-3.24a5.47 5.47 0 0 1 2.112-2.28q1.416-.864 3.456-.864 1.512 0 2.64.48 1.152.456 1.896 1.224a4.7 4.7 0 0 1 1.128 1.656q.384.912.384 1.824a5.14 5.14 0 0 1-.648 2.52q-.648 1.176-1.704 2.136l-4.368 4.128h7.032V37z"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    x: 776,
    y: 8,
    fill: "#51C394",
    rx: 20
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    x: 772,
    y: 4,
    stroke: "#51C394",
    strokeOpacity: 0.5,
    strokeWidth: 8,
    rx: 24
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M795.772 28.816V27.16a4.2 4.2 0 0 0 1.32-.192 3 3 0 0 0 1.008-.528q.408-.36.624-.792.24-.456.24-.936 0-.6-.24-1.056a1.62 1.62 0 0 0-.696-.696q-.456-.24-1.176-.24-1.008 0-1.704.624-.672.6-.672 1.536h-3.192q0-1.44.696-2.544a5.04 5.04 0 0 1 1.968-1.776q1.248-.648 2.904-.648 1.752 0 2.976.624 1.248.624 1.896 1.656t.648 2.304q0 1.368-.864 2.352-.864.96-2.352 1.464t-3.384.504m.936 8.52q-1.44 0-2.568-.432a5.8 5.8 0 0 1-1.92-1.176A5.6 5.6 0 0 1 790.996 34a5.1 5.1 0 0 1-.432-2.064h3.408q0 .816.384 1.392t1.032.888q.648.288 1.416.288.792 0 1.368-.264.6-.288.936-.816t.336-1.32q0-.576-.24-1.056-.24-.504-.72-.84-.456-.336-1.152-.504-.672-.192-1.56-.192v-1.824q1.536 0 2.808.264 1.296.264 2.256.864.96.576 1.488 1.488.528.888.528 2.16 0 1.44-.768 2.544-.744 1.104-2.136 1.728-1.368.6-3.24.6"
  })));
};
export default SvgMilestones;